var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrivateModeOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "Rectangle_18694",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.098
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19095",
    "data-name": "Rectangle 19095",
    width: 31,
    height: 31,
    transform: "translate(1725 88)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Private_mode_off",
    "data-name": "Private mode off",
    transform: "translate(-1706 -72)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1706, 72)",
    filter: "url(#Rectangle_18694)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_18694-2",
    "data-name": "Rectangle 18694",
    width: 50,
    height: 50,
    rx: 4,
    transform: "translate(9 6)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Private_off",
    "data-name": "Private off",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10194",
    "data-name": "Group 10194"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M2013.656,26.042a5.113,5.113,0,0,1-5.116-4.886h-2.079a5.123,5.123,0,0,1-8.049,3.964l.779-.779a4.042,4.042,0,0,0,5.574-5.574l.779-.779a5.1,5.1,0,0,1,.917,2.7v-.334h2.105a5.1,5.1,0,1,1,5.09,5.688Zm0-9.163a4.041,4.041,0,1,0,4.042,4.041A4.046,4.046,0,0,0,2013.656,16.88Zm-17.389,4.729v0a5.2,5.2,0,0,1-.046-.686,5.173,5.173,0,0,1,5.123-5.122,5.188,5.188,0,0,1,.687.046l-1.051,1.052a4.033,4.033,0,0,0-3.66,3.66l-1.051,1.051ZM2023,13.965h-13.433l3.684-3.684A29.2,29.2,0,0,1,2023,13.963Zm-19.09,0H1992a30.8,30.8,0,0,1,15.449-4.246c.231,0,.466,0,.7.008l-4.237,4.238Zm12.614-5.341h-1.615l1.291-1.291.324,1.29Zm-7.273,0h-10.773l2.561-8.153c.019-.029.09-.044.2-.044a12.022,12.022,0,0,1,3.131.772,6.676,6.676,0,0,0,2.23.388,4.936,4.936,0,0,0,1.2-.13c.036-.007,3.692-.664,5.169-1.011a2.882,2.882,0,0,1,.648-.084c.878,0,.973.6.974.6l.465,1.849-5.81,5.811Z",
    transform: "translate(-267 90.297)",
    fill: "#3d7cc9"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_19097",
    "data-name": "Rectangle 19097",
    width: 2,
    height: 40,
    rx: 1,
    transform: "translate(1753.935 88.651) rotate(45)",
    fill: "#3d7cc9"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrivateModeOff);
export default __webpack_public_path__ + "static/media/private_mode_off.ad387dca15fa638b5f4aca077e878883.svg";
export { ForwardRef as ReactComponent };